import { gql } from "@apollo/client";

export const getLiveLocationQuery = gql`
query($date: String!, $employeeId: String!, $scheduleId: String!){
  getLiveLocation(date: $date, employeeId: $employeeId, scheduleId: $scheduleId) {
    message
    response
  }
}
`;